import { w } from 'windstitch';

export const Wrapper = w.div(
  'w-full px-4 xl:p-0 xl:w-[1200px]',
);

export const Title = w.h2(
  'font-roboto font-bold text-[32px] lg:text-[48px] leading-[56px] tracking-[2px] text-center',
);

export const Text = w.p(
  'm-[48px] font-open-sans font-normal text-base leading-6 tracking-[0px] text-center text-[14px] lg:text-[16px]',
);

export const CardSolo = w.div(
  'w-full xl:w-[1200px] lg:h-[141px] rounded-[24px] p-[32px] border border-[var(--lime-500)] md:flex flex-wrap gap-2 justify-center items-center gap-x-[53px] bg-[var(--marine-500)]',
);

export const TextCardSolo = w.p(
  'text-[var(--marine-25)] w-full md:w-[425px] font-open-sans font-semibold text-[20px] lg:text-[24px] leading-[32px] tracking-[0px] flex items-center ',
);

export const SpanCardSolo = w.span(
  'w-[14px] h-[14px] bg-[var(--lime-500)] rounded-full mr-[12px] block',
);

